<template>
<div>
    <br>
En cours de construction... soyez patients !!
    <br>
</div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'myAccount',
  components: {
  },
  props: {
  },
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'matchReportList'
    ])
  },
  created () {
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.big-title {
    font-size: 1.6rem;
}
.match-header:hover {
    background-color: #eeeeee;
    cursor: pointer;
}
.billboard {
    background-color: rgba(255,255,255,0.9);
    border-width: 1px;
    border-style: solid;
    border-color: #E1E5EC;
    margin: 1rem 0rem 1rem 0rem;
    box-shadow: 0 1px 3px rgba(0,0,0,0.12),0 1px 2px rgba(0,0,0,0.24);
    -webkit-transition: opacity 0.2s, -webkit-transform 0.2s;
	transition: opacity 0.35s, transform 0.5s;
    overflow: hidden;
}

.billboard:hover {
    -webkit-transform: scale3d(0.9,0.9,0.9);
	transform: scale3d(1.1,1.1,1);
    box-shadow: 1px 1px 3px rgba(0,0,0,0.7);
}

.billboard-thumbnail {
    padding: 0rem;
    margin: 0rem;
}

.billboard-content {
    padding: 1rem 1rem;
    overflow: inherit;
}
.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}


.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ; 
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.router-link-exact-active {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}
</style>



// WEBPACK FOOTER //
// my-teams.vue?ed1ba524